export const HOME = '/';
export const SIGNIN = '/customer/account/login';
export const CART = '/checkout/cart';
export const PRESCRIPTIONS = '/prescriptions';
export const NON_PRESCRIPTIONS = '/non-prescriptions';
export const PRODUCT_DETAILS = '/non-prescriptions';
